import { jsx as r } from "react/jsx-runtime";
import n from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as t } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
const m = n.div`
  --circle-diameter: ${(e) => e.size === "large" ? e.theme.components.spinner.SpinnerCircle.circleDiameter.large : e.size === "medium" ? e.theme.components.spinner.SpinnerCircle.circleDiameter.medium : e.theme.components.spinner.SpinnerCircle.circleDiameter.default};
  --line-weight: ${(e) => e.theme.components.spinner.SpinnerCircle.lineWeight};
  position: ${(e) => e.theme.components.spinner.SpinnerCircle.position};
  width: var(--circle-diameter);
  height: var(--circle-diameter);

  &::before {
    position: ${(e) => e.theme.components.spinner.SpinnerCircle.before.position};
    content: '';
    top: ${(e) => e.theme.components.spinner.SpinnerCircle.before.top};
    left: ${(e) => e.theme.components.spinner.SpinnerCircle.before.left};
    width: var(--circle-diameter);
    height: var(--circle-diameter);
    bottom: ${(e) => e.theme.components.spinner.SpinnerCircle.before.bottom};
    right: ${(e) => e.theme.components.spinner.SpinnerCircle.before.right};
    box-sizing: ${(e) => e.theme.components.spinner.SpinnerCircle.before.boxSizing};
    margin-left: calc(var(--circle-diameter) / -2);
    border-radius: var(--circle-diameter);
    border: var(--line-weight) ${(e) => e.theme.components.spinner.SpinnerCircle.before.borderStyle};
  }
`, c = n.div`
  position: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.position};

  &::before {
    position: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.position};
    content: '';
    width: var(--circle-diameter);
    height: var(--circle-diameter);
    left: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.left};
    box-sizing: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.boxSizing};
    margin-left: calc((var(--circle-diameter)) / -2);
    border-radius: var(--circle-diameter);
    border: var(--line-weight) ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.borderStyle};
    border-top: var(--line-weight) ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.borderTopStyle};
    transform: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.transform};
    animation-name: circularindetermiate;
    animation-iteration-count: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.animationIterationCount};
    animation-duration: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.animationDuration};
    animation-timing-function: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.animationTimingFunction};
  }

  @keyframes circularindetermiate {
    100% {
      transform: ${(e) => e.theme.components.spinner.SpinnerCircleProgressBar.before.keyFrames.transform};
    }
  }
`, b = ({ size: e, ...i }) => {
  const o = t({ label: "Spinner" });
  return /* @__PURE__ */ r(
    m,
    {
      color: "red",
      size: e,
      ...i,
      ...o,
      children: /* @__PURE__ */ r(c, { color: "red" })
    }
  );
};
export {
  b as Spinner
};
